"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetryOrderUtils = void 0;
const TradeAPILib_1 = require("TradeAPILib");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const decimal_js_1 = __importDefault(require("decimal.js"));
const GridUtils_1 = require("./GridUtils");
const DCATradeUtils_1 = require("../Trading/DCATrading/DCATradeUtils");
const TWAPTradeUtils_1 = require("./TWAPTradeUtils");
const NumberTradeUtils_1 = require("./NumberTradeUtils");
const SimpleTrading_1 = require("../Trading/SimpleTrading");
exports.RetryOrderUtils = {
    /**
     *  检查Grid订单恢复条件
     * @param order
     * @param apiKey
     * @param themeData
     */
    checkGridOrderRestore(order, tradeApi, balanceObserve, $st, exchange) {
        const gridOrder = order.exchangeGridOrder;
        if (!gridOrder || !order.exchange || !gridOrder.canRetry) {
            return (0, rxjs_1.of)({ result: false });
        }
        // 1.获取公共参数
        return this.queryRetryCommonParams(order, tradeApi, balanceObserve)
            .pipe((0, operators_1.mergeMap)((params) => {
            let minPerVolume = SimpleTrading_1.SimpleTrading.getMinAmount(params.symbol, gridOrder.low) || 0;
            minPerVolume = NumberTradeUtils_1.NumberTradeUtils.toAmountNumBySymbol(tradeApi, minPerVolume, params.symbol, decimal_js_1.default.ROUND_UP);
            const checkErr = GridUtils_1.GridUtils.checkBalanceEnoughRequest(gridOrder.high, gridOrder.low, gridOrder.amount, gridOrder.number, params.baseBalance, params.quoteBalance, $st, gridOrder.stop, minPerVolume);
            if (checkErr) {
                throw checkErr;
            }
            // 2.checkRequiredBalance
            return GridUtils_1.GridUtils.checkGridBalance(params.symbol, params.baseBalance, params.quoteBalance, gridOrder.high, gridOrder.low, gridOrder.amount, gridOrder.number, tradeApi, exchange).pipe((0, operators_1.map)((result) => {
                return GridUtils_1.GridUtils.processCheckGridBalanceResult(result, params.symbol, params.baseBalance, params.quoteBalance, tradeApi, $st, params.ticker.latest);
            }));
        }))
            .pipe((0, operators_1.mergeMap)((result) => {
            if (!result.canCreate) {
                throw result.error;
            }
            if (result.needBalance) {
                return (0, rxjs_1.of)({ result: true, msg: result.balanceMsg });
                //
                // return PionexAlertShow($st("waring"), result.balanceMsg, themeData)
                //     .pipe(map(result => {
                //         return {result: !!result}
                //     }))
            }
            return (0, rxjs_1.of)({ result: true });
        }))
            .pipe((0, operators_1.catchError)((error) => {
            return (0, rxjs_1.of)({ result: false, msg: error });
        }));
    },
    /**
     *  检查DCA订单恢复条件
     * @param order
     * @param apiKey
     */
    checkDCAOrderRestore(order, tradeApi, balanceObserve, exchange, $st) {
        const aipOrder = order.exchangeAIPOrder;
        if (!aipOrder || !aipOrder.canRetry) {
            return (0, rxjs_1.of)({ result: false });
        }
        let commonParams;
        return this.queryRetryCommonParams(order, tradeApi, balanceObserve)
            .pipe((0, operators_1.mergeMap)((result) => {
            commonParams = result;
            return tradeApi.queryAipLimit(result.symbol, exchange);
        }))
            .pipe((0, operators_1.map)((result) => {
            let minCost = 0;
            if (result && result.cost && result.cost.min) {
                minCost = result.cost.min;
            }
            const precision = commonParams.symbol.precision !== undefined ? commonParams.symbol.precision : 4;
            const createErr = DCATradeUtils_1.DCATradeUtils.checkCreateOrder(aipOrder.perVolume, aipOrder.interval, minCost, commonParams.quoteBalance, precision, $st);
            if (createErr) {
                return { result: false, msg: createErr };
            }
            else {
                return { result: true };
            }
        }));
    },
    /**
     * 检查TWAP订单恢复条件
     * @param order
     * @param apiKey
     */
    checkTWAPOrderRestore(order, tradeApi, balanceObserve, exchange, $st) {
        const twapOrder = order.exchangeTWAPOrder;
        if (!twapOrder || !twapOrder.canRetry) {
            return (0, rxjs_1.of)({ result: false });
        }
        let commonParams;
        return this.queryRetryCommonParams(order, tradeApi, balanceObserve)
            .pipe((0, operators_1.mergeMap)((result) => {
            commonParams = result;
            return tradeApi.queryAipLimit(commonParams.symbol, exchange);
        }))
            .pipe((0, operators_1.map)((result) => {
            let minCost = 0;
            if (result && result.cost && result.cost.min) {
                minCost = result.cost.min;
            }
            const side = twapOrder.side === "buy" ? TradeAPILib_1.ExchangeOrderSide.buy : TradeAPILib_1.ExchangeOrderSide.sell;
            const precision = commonParams.symbol.precision !== undefined ? commonParams.symbol.precision : 4;
            const createErr = TWAPTradeUtils_1.TWAPTradeUtils.checkLocalError(twapOrder.totalTimes, twapOrder.totalVolume, minCost, commonParams.quoteBalance, precision, commonParams.symbol.quote, side, $st);
            if (createErr) {
                return { result: false, msg: createErr };
            }
            else {
                return { result: true };
            }
        }));
    },
    queryRetryCommonParams(order, tradeApi, balanceObserve) {
        const { base, quote } = order;
        const symbolOb = tradeApi.getSymbolInfoObservable(base, quote);
        const tickerOb = tradeApi.queryRestSymbolTicker(base, quote);
        const balanceOb = balanceObserve()
            .pipe((0, operators_1.skip)(2), (0, operators_1.take)(1))
            .pipe((0, operators_1.map)((balances) => {
            let baseBalance = 0;
            let quoteBalance = 0;
            for (const item of balances) {
                if (item.currency.toUpperCase() === base) {
                    baseBalance = item.available;
                }
                else if (item.currency.toUpperCase() === quote) {
                    quoteBalance = item.available;
                }
                if (baseBalance && quoteBalance) {
                    break;
                }
            }
            return { baseBalance: baseBalance, quoteBalance: quoteBalance };
        }));
        return (0, rxjs_1.zip)(symbolOb, tickerOb, balanceOb).pipe((0, operators_1.map)((result) => {
            const symbol = result[0];
            const ticker = result[1];
            const baseBalance = result[2].baseBalance;
            const quoteBalance = result[2].quoteBalance;
            const totalBalance = baseBalance * ticker.latest + quoteBalance;
            const params = {
                symbol,
                ticker,
                baseBalance: NumberTradeUtils_1.NumberTradeUtils.toAmountNumBySymbol(tradeApi, baseBalance, symbol),
                quoteBalance: NumberTradeUtils_1.NumberTradeUtils.toPriceNumBySymbol(tradeApi, quoteBalance, symbol),
                totalBalance: NumberTradeUtils_1.NumberTradeUtils.toPriceNumBySymbol(tradeApi, totalBalance, symbol),
            };
            return params;
        }));
    },
};
